module.exports = __webpack_public_path__ + "img/E2.36f71bd1.png";